export enum TooltipDirection {
  bottomRight = "bottom-right",
  bottomLeft = "bottom-left",
  topRight = "top-right",
  topLeft = "top-left",
}